export default function() {
    return {
        overflowHidden: false,
        mobileMenu: false,
        isHeaderHidden: false,

        init() {}
    };
}
